import { render, staticRenderFns } from "./ExportStudentsBalanceOverview.vue?vue&type=template&id=06ea3fcd&"
import script from "./ExportStudentsBalanceOverview.vue?vue&type=script&lang=ts&"
export * from "./ExportStudentsBalanceOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports